<template>
    <b-navbar toggleable="xl" fixed="top" v-b-scrollspy:nav-scroller class="header-area text-white" :class="{'is-sticky': scrolled}">
        <div class="container-fluid container-fluid--cp-150">
            <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
            <b-navbar-brand class="navbar-brand logo-light text-white" to="/home">
                <!-- <img :src='"@/assets/static-img/logo/light-logo.png"' alt="logo"> -->
                <logo class="w-48 mr-2 fill-current" />
                <!-- <span class="vx-logo-text">QuickSend</span> -->
            </b-navbar-brand>
            <b-navbar-brand class="navbar-brand logo-dark" to="/home">
                <!-- <img :src='"@/assets/static-img/logo/logo-dark.png"' alt="logo"> -->
                <logo class="w-48 mr-2 fill-current" />
                <!-- <span class="vx-logo-text">QuickSend</span> -->
            </b-navbar-brand>
            <b-collapse class="default-nav justify-content-center"  is-nav id="nav_collapse">
                <b-navbar-nav class="navbar-nav main-menu text-white">
                    <!-- <b-nav-item to="/"><span>LANDING</span></b-nav-item> -->
                    <b-nav-item to="/home" class="scroll"><span>HOME</span></b-nav-item>
                    <b-nav-item to="/home" class="scroll"><span>FEATURES</span></b-nav-item>
                    <b-nav-item to="/home" class="scroll"><span>HOW IT WORKS</span></b-nav-item>
                    <b-nav-item to="/home" class="scroll"><span>PRICING</span></b-nav-item>
                    <!-- <b-nav-item href="#clients" class="scroll"><span>CLIENTS</span></b-nav-item> -->
                </b-navbar-nav>
            </b-collapse>
            <b-btn-group class="header-button button--white d-none d-xl-block">
                <b-link class="btn btn--white btn-login" to="/login">Log In</b-link>
                <b-link class="btn btn--white btn-signup" to="/signup">Sign Up</b-link>
            </b-btn-group>
        </div>
    </b-navbar>
</template>

<script>
import Logo from '@/layouts/components/Logo.vue'

    export default {
        components: {
            Logo
        },
        name:'Navbar',
        data (){
            return {
                load: false,
                limitPosition: 200,
                scrolled: false,
                lastPosition: 500,
            }
        },
        mounted (){
            (function() {
                scrollTo();
            })();

            function scrollTo() {
                const links = document.querySelectorAll('.scroll > a');
                links.forEach(each => (each.onclick = scrollAnchors));
            }

            function scrollAnchors(e, respond = null) {
                const distanceToTop = el => Math.floor(el.getBoundingClientRect().top);
                e.preventDefault();
                var targetID = (respond) ? respond.getAttribute('href') : this.getAttribute('href');
                const targetAnchor = document.querySelector(targetID);
                if (!targetAnchor) return;
                const originalTop = distanceToTop(targetAnchor);
                window.scrollBy({ top: originalTop, left: 0, behavior: 'smooth' });
                const checkIfDone = setInterval(function() {
                    const atBottom = window.innerHeight + window.pageYOffset >= document.body.offsetHeight - 190;
                    if (distanceToTop(targetAnchor) === 0 || atBottom) {
                        targetAnchor.tabIndex = '-1';
                        targetAnchor.focus();
                        //window.history.pushState('', '', targetID);
                        clearInterval(checkIfDone);
                    }
                }, 800);
            }
        },
        methods: {
            // sticky menu script
            handleScroll() {
                if (this.lastPosition < window.scrollY && this.limitPosition < window.scrollY) {
                    this.scrolled = true;
                    // move up!
                } 
                
                if (this.lastPosition > window.scrollY) {
                    this.scrolled = true;
                    // move down
                }
                
                this.lastPosition = window.scrollY;
                this.scrolled = window.scrollY > 50;
            }
        }, 
        created() {
            window.addEventListener("scroll", this.handleScroll);
        },
        destroyed() {
            window.removeEventListener("scroll", this.handleScroll);
        },
    }
</script>

<style>
    .vx-logo-text{
        font-size: 22px;
        font-weight: 600;
        animation: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) 0s normal forwards 1 fadein;
    }
    .text-primary {
        color: #F9278E !important;
    }
    .logo-dark {
        color: #F9278E !important;
    }
    .btn-login {
        background: transparent !important;
        color: #ffffff !important;
        border: #ffffff 1px solid !important;
    }    
    .header-area.is-sticky .btn-login {
        border: 2px solid #F9278E !important;
        color: #F9278E !important;
    }
    .header-area.is-sticky .btn-signup {
        background: #F9278E !important;
        color: #ffffff !important;
    }
</style>
